export const TITLES = {
  IDENTIFICATION: 'Identificação',
  COMERCIAL_CONDITIONS: 'Condições comerciais',
  ADDITIONAL_SERVICES: 'Serviços adicionais (obrigatórios e opcionais)',
  REFUNDS: 'Reembolsos',
}

export const MERCHANT_IDENTIFICATION = {
  designation: 'Oferta Comercial',
  commercial_offer_modality: 'Modalidade da oferta comercial',
  description: 'Descrição da Oferta Comercial',
  market_segment_type: 'Segmento da oferta',
  commercial_offer_website: 'Endereço web da oferta comercial',
  website_standardized_contract_form:
    'Endereço web da ficha contratual padronizada',
  website_contract_conditions: 'Endereço web das condições gerais do contrato',
  contacts: 'Contrato Comercial Telefónico',
  email_contact: 'Contrato Comercial Eletrónico',
  website_contact: 'Contacto Comercial Eletrónico',
}

export const SUPPORT_OPTIONS = [
  {
    slug: 'w',
    text: 'Por escrito',
  },
  {
    slug: 'p',
    text: 'Presencial',
  },
  {
    slug: 't',
    text: 'Telefónico',
  },
  {
    slug: 'e',
    text: 'Eletrónico',
  },
]

export const BILLING_TYPE = {
  electronic_billing: 'Electrónica',
  paper_billing: 'Papel',
}

export const CONTRACT_TYPE = {
  email_contract_contact: 'Electrónica',
  location_contract_contact: 'Presencial',
  phone_contract_contact: 'Telefone',
}

export const PAYMENT_TYPE = {
  direct_debit: 'Débito direto em conta',
  atm_ctt: 'Multibanco / Transferência bancária',
  shop_payment: 'Loja / Agente autorizado',
}

export const ADDITIONAL_RESTRICTIONS = {
  partnerships: 'Obriga a parcerias com outras instituições',
  equipments: 'Destina-se a algum tipo de equipamento específico',
  consumers: 'Destina-se a um grupo de consumidores específico',
  consumptions: 'Obriga a consumos de energia mínimos/máximos',
}

export const COMERCIAL_CONDITIONS = {
  offer_type: 'Tipo de fornecimento',
  contract_duration: 'Duração do contrato (meses)',
  offer_start_date: 'Data de início da oferta comercial',
  offer_validity: 'Data de validade da oferta comercial',
  contract_type: 'Contratação',
  billing_type: 'Faturação',
  payment_type: 'Métodos de Pagamento',
  direct_debit: 'Débito direto em conta',
  atm_ctt: 'Multibanco / Transferência bancária',
  shop_payment: 'Loja / Agente autorizado',
  support_options: 'Meios de Atendimento',
  payment_periodicity: 'Modalidades de Faturação',
  has_loyalty: 'Fidelização?',
  loyalty_clauses_description:
    'Descrição das cláusulas de fidelização, incluindo a penalização por rescisão antecipada',
  green_energy: 'Energia elétrica com origem 100% renovável',
  has_additional_restrictions: 'Restrições adicionais',
  additional_restrictions: 'Restrições adicionais',
  offer_restrictions:
    'Detalhe as restrições anteriores e/ou outras aplicáveis.',
  price_function_of_access:
    'A tabela de preços é atualizada em função das tarifas de acesso às redes?',
  price_revision_conditions:
    'Outras políticas de atualização da tabela de preços',
  indexed_prices:
    'Preços indexados - existem mecanismos de revisão de preços inferiores a um ano?',
}

export const ADDITIONAL_SERVICES = {
  required_subscription_additional_services:
    'Obrigatoriedade de contratação de serviços adicionais?',
  additional_services_cost:
    'Custo dos serviços adicionais obrigatórios (€/ano) sem IVA',
  optional_services_description:
    'Descrição dos serviços adicionais opcionais relevantes',
}

export const REFUNDS_ENTRIES = {
  has_refunds: 'A oferta tem reembolsos?',
  annual_refunds: 'Reembolsos anuais',
  refunds_description: 'Descrição de todos os reembolsos da oferta comercial',
}



// WEBPACK FOOTER //
// ./src/components/DetailsModalV2/information-entries.js